import styled from 'styled-components'
import { Layout } from 'antd'

export const StyledContent = styled(Layout.Content)`
  padding: 2rem 3rem;
  min-height: calc(100vh - 4rem);
`



// WEBPACK FOOTER //
// ./src/hoc/MainLayout/styled.js